import { getDropdownOptions } from "helpers/DropdownHelper";
import {
    NotificationSource,
    NotificationSourceTranslation,
    RoleType,
} from "modules/common/constants";
import React, { useEffect, useState } from "react";
import { Filter, ToggleSwitch } from "..";
import { useAccessToken } from "modules/common/hooks";
import { useSelector } from "react-redux";
import { RootState } from "store";

interface Props {
    onChange: (source: NotificationSource) => void;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
    isActive: boolean;
    showDropdown: boolean;
    value: NotificationSource[];
}

export const NotificationSourceFilter: React.FC<Props> = ({
    onChange,
    onClick,
    onClear,
    isActive,
    showDropdown,
    value,
}) => {
    const accessToken = useAccessToken();
    const [options, setOptions] = useState<{ label: string; value: NotificationSource }[]>([]);
    const userRole = useSelector((state: RootState) => state.signIn.user?.role);
    useEffect(() => {
        const fetchData = async () => {
            const allOptions = getDropdownOptions(NotificationSourceTranslation);

            const filtered =
                userRole?.value === RoleType.Citizen
                    ? allOptions.filter(
                          option => option.value !== NotificationSource.Record && option.value !== NotificationSource.Education
                      )
                    : allOptions;

            setOptions(filtered);
        };

        fetchData();
    }, [accessToken, userRole]);

    return (
        <Filter
            isActive={isActive}
            showDropdown={showDropdown}
            onClear={onClear}
            onClick={onClick}
            text="IZVOR"
        >
            {options.map(option => (
                <div key={option.value}>
                    <ToggleSwitch
                        value={option.label}
                        checked={value.includes(option.value)}
                        onChange={() => onChange(option.value)}
                        htmlFor={option.label}
                        text={
                            <div className="filter__item__text">
                                {option.label.toLocaleUpperCase()}
                            </div>
                        }
                    />
                </div>
            ))}
        </Filter>
    );
};
